import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { FormsModule } from '@angular/forms';
import { TranslationService } from '../services/translation.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  username = '';
  password = '';
  errorMessage = '';
  isLoading = false; // Estado para la animación de carga
  currentLanguage: string = 'es';
  showPassword = false; // Controla la visibilidad de la contraseña

  constructor(
    private authService: AuthService, 
    private router: Router,
    public translationService: TranslationService
  ) {}

  ngOnInit() {
    this.translationService.currentLanguage$.subscribe(lang => {
      this.currentLanguage = lang; // Se actualiza el idioma al cambiar
    });
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  login(): void {
    this.isLoading = true; // Inicia la animación de carga
    this.errorMessage = ''; // Limpia el mensaje de error previo

    this.authService.login({ username: this.username, password: this.password, }).subscribe({
      next: () => {
        this.authService.fetchUserRole().subscribe(() => {
          this.router.navigate(['/']); // Redirige al dashboard después de iniciar sesión
        });
      },
      error: () => {
        this.isLoading = false; // Detiene la animación en caso de error
        this.errorMessage = this.translationService.getTranslation('CredencialesIncorrectas');
      }
    });
  }
}

